import LiquidValidator from 'Shared/components/LiquidValidator/LiquidValidator'
import Step from './Step'
import InlineCkEditor from 'Shared/components/CKEditor/InlineCkEditor'

function InstructionsShortDescriptor({ complete, instructions }) {
  return <div>
    {complete && <>
      <p className='incomplete margin-bottom'>These instructions will appear to volunteers before they start calling.</p>
      <div dangerouslySetInnerHTML={{ __html: instructions }} />
    </> }
    {!complete && <p className='incomplete no-margin-bottom'>Add instructions which will appear to volunteers before they start calling.</p>}
  </div>
}

export default function Instructions() {
  const act = useAct()
  const { instructions } = useSel(s => s.campaign)
  const complete = !!instructions && instructions != '<p></p>' // default empty string given by editor
  const { mergeTags } = useSel(s => s.campaignBuilder)

  function onChange(html) {
    act.campaign.upsert({ instructions: html })
  }

  return <Step
    name='Instructions'
    editor='instructions'
    complete={complete}
    canClickFinish={complete}
    shortDescriptor={<InstructionsShortDescriptor complete={complete} instructions={instructions} />}
  >
    <InlineCkEditor
      value={instructions}
      onUpdate={onChange}
      mergeTags={mergeTags}
      features={[]}
    />
    <LiquidValidator value={instructions} lineSplitTags={true} availableTags={mergeTags} />
  </Step>
}
